import React, { useState,  } from "react";
import axios from "axios";

function Logs({ currentUser }) {

  const [filteredData, setFilteredData] = useState([]); // initially empty
  const [allFields, setAllFields] = useState([]);
  const [filters, setFilters] = useState({
    phone: "",
    cardNumber: "",
    accountNumber: "",
    fromDate: "",
    toDate: "",
    userCenter: "",
  });
const [loading, setLoading] = useState(false);



  // ✅ Safe value rendering
  const renderValue = (value) => {
    if (value === null || value === undefined) return "";
    if (typeof value === "object") return JSON.stringify(value);
    return value.toString();
  };
// const convertToMMDDYYYY = (dateStr) => {
//   // dateStr from <input type="date"> → "YYYY-MM-DD"
//   const [year, month, day] = dateStr.split("-");
//   return `${month}/${day}/${year}`; // → "MM/DD/YYYY"
// };

const handleFilter = async () => {
  setLoading(true); 

  const params = new URLSearchParams();
  if (filters.phone) params.append("phone", filters.phone);
  if (filters.cardNumber) params.append("cardNumber", filters.cardNumber);
  if (filters.accountNumber) params.append("accountNumber", filters.accountNumber);
  if (filters.userCenter) params.append("userCenter", filters.userCenter);
  if (filters.fromDate) params.append("fromDate", filters.fromDate);
  if (filters.toDate) params.append("toDate", filters.toDate);

  try {
    const res = await axios.get(
      `https://crm-server-htk6.vercel.app/api/logs?${params.toString()}`
    );

    const logs = res.data || [];
    setFilteredData(logs);

    // Extract all unique keys
    if (logs.length > 0) {
      const keys = Array.from(
        logs.reduce((acc, row) => {
          Object.keys(row).forEach(k => acc.add(k));
          return acc;
        }, new Set())
      );

      const priorityFields = [
        "logDate",
        "phone",
        "cardNumber",
        "accountNumber",
        "userCenter",
        "user",
      ];

      const reordered = [
        ...priorityFields.filter(f => keys.includes(f)),
        ...keys.filter(f => !priorityFields.includes(f))
      ];

      setAllFields(reordered);
    } else {
      setAllFields([]);
    }

  } catch (error) {
    console.error("❌ Filter Error:", error);
  } finally {
    setLoading(false);
  }
};

// Ensure CustomerID is the first column
const orderedFields = [
  "CustomerID",
  ...allFields.filter(f => f !== "CustomerID")
];


  return (
    <div className="logs-page-container" style={{ position: "relative" }}>
     

      <h2>Logs</h2>

      {/* 🔹 Filter Bar */}
      <div className="filter-bar" style={{ marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Phone"
          value={filters.phone}
          onChange={(e) => setFilters({ ...filters, phone: e.target.value })}
        />
        <input
          type="text"
          placeholder="Card Number"
          value={filters.cardNumber}
          onChange={(e) =>
            setFilters({ ...filters, cardNumber: e.target.value })
          }
        />
        <input
          type="text"
          placeholder="Account Number"
          value={filters.accountNumber}
          onChange={(e) =>
            setFilters({ ...filters, accountNumber: e.target.value })
          }
        />
        <input
          type="text"
          placeholder="User Center"
          value={filters.userCenter}
          onChange={(e) =>
            setFilters({ ...filters, userCenter: e.target.value })
          }
        />
        <input
          type="date"
          value={filters.fromDate}
          onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
        />
        <input
          type="date"
          value={filters.toDate}
          onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
        />

        <button onClick={handleFilter}>Apply Filter</button>
        <button onClick={() => setFilteredData([])}>Reset</button>
      </div>

      {/* 🔹 Scrollable Table */}
      <div className="table-container" style={{ overflowX: "auto" }}>

      {loading && (
  <div style={{ padding: "10px", fontWeight: "bold", color: "blue" }}>
    Fetching data, please wait...
  </div>
)}

    <table className="log-table" border="1" cellPadding="5">
  <thead>
    <tr>
      {orderedFields.map((field, i) => (
        <th key={i}>{field}</th>
      ))}
    </tr>
  </thead>
  <tbody>
    {filteredData.length === 0 ? (
      <tr>
        <td colSpan={orderedFields.length} style={{ textAlign: "center" }}>
          No logs to display. Apply filters to view data.
        </td>
      </tr>
    ) : (
      filteredData.map((row, i) => (
        <tr key={i}>
          {orderedFields.map((field, j) => (
            <td key={j}>{renderValue(row[field])}</td>
          ))}
        </tr>
      ))
    )}
  </tbody>
</table>

      </div>
    </div>
  );
}

export default Logs;
